<template>
  <v-card class="mx-10">
    <v-card-title>
      <span class="text-h6">Agregar Servicio</span>
      <v-spacer></v-spacer>

      <v-btn
        class="mr-4"
        small
        title="Calendario de Sevicios"
        color="primary"
        @click="$emit('changeView', 'calendario')"
      >
        <v-icon>mdi-calendar-month</v-icon>
      </v-btn>
      <v-btn
        class="mr-4"
        title="Listado de Servicios"
        small
        color="primary"
        @click="$emit('changeView', 'listado')"
      >
        <v-icon>mdi-format-list-bulleted</v-icon>
      </v-btn>
    </v-card-title>
    <!--Formulario para la carga de servicio-->
    <v-form ref="form">
      <v-row justify="center" align="center" class="px-10">
        <!-- Servicio -->
        <v-col cols="12">
          <v-select
            v-model="template"
            :items="templates"
            item-text="name"
            item-value="id"
            label="SERVICIO"
            outlined
            dense
            hide-details
            required
          ></v-select>
        </v-col>

        <v-col cols="10">
          <v-text-field
            v-model="plate"
            label="PATENTE"
            outlined
            dense
            hide-details
            @keyup.enter="fetchVehicles"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-btn icon color="primary" @click="openVehicleModal">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="1">
          <v-btn
            title="Buscar Vehículo"
            icon
            color="primary"
            @click="searchVehicleModal"
          >
            <v-icon>mdi-car-search</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="vehicleSelected.make"
            label="MARCA"
            outlined
            dense
            hide-details
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="vehicleSelected.model"
            label="MODELO"
            outlined
            dense
            hide-details
            disabled
          ></v-text-field>
        </v-col>
        <v-divider class="my-4"></v-divider>
        <!-- Cliente con búsqueda y modal -->
        <v-col cols="10">
          <v-text-field
            v-model="dni"
            label="DNI"
            outlined
            dense
            hide-details
            @keyup.enter="fetchClient"
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-btn icon color="primary" @click="openClientModal">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="1">
          <v-btn
            title="Buscar Cliente"
            icon
            color="primary"
            @click="searchClientModal"
          >
            <v-icon>mdi-account-search</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="completeName"
            label="NOMBRE"
            outlined
            dense
            hide-details
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="clientSelected.address"
            label="DIRECCION"
            outlined
            dense
            hide-details
            disabled
          ></v-text-field>
        </v-col>
        <!-- Kilometraje -->
        <v-col cols="12">
          <v-text-field
            v-model="kmIn"
            label="Km"
            outlined
            dense
            required
            type="number"
            @input="kmIn = kmIn.replace(/[^0-9]/g, '')"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <!-- Campo de Fecha -->
          <v-text-field
            v-model="date"
            label="Fecha"
            type="date"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <!-- Campo de Hora Desde -->
          <v-text-field
            v-model="timeFrom"
            label="Hora Desde"
            type="time"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <!-- Campo de Hora Hasta -->
          <v-text-field
            v-model="timeTo"
            label="Hora Hasta"
            type="time"
            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-overlay :value="overlay" :z-index="3000">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="saveService">Guardar</v-btn>
    </v-card-actions>
    <!-- Modal para agregar Cliente -->
    <ClientDialog v-model="clientModal" @save-client="onClientSaved" />
    <!-- Modal para buscar Cliente -->
    <v-dialog v-model="searchClientDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline">Seleccionar Cliente</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersClient"
            :items="clients"
            item-value="id"
            dense
            class="elevation-1"
            :search="searchCli"
          >
            <template v-slot:top>
              <v-text-field
                v-model="searchCli"
                label="Buscar"
                outlined
                dense
                class="mx-4 small-input"
              ></v-text-field>
            </template>
            <template v-slot:item="{ item }">
              <tr @click="selectClient(item)" class="clickable-row">
                <td>{{ item.dni }}</td>
                <td>{{ item.first_name }}</td>
                <td>{{ item.last_name }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.address }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="searchClientDialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Modal para agregar Vehículo -->
    <v-dialog v-model="vehicleModal" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Agregar Vehículo</v-card-title>
        <v-card-text>

          <VehicleForm
            ref="vehicleForm"
            mode="add"
            :vehicleData="vehicle"
            source="servicio"
            :visibleFields="visibleFields"
            @save="addVehicle"
            @close="vehicleModal = false"
          />
        </v-card-text>
        <!-- <v-card-actions>
            <v-btn color="primary" @click="addVehicle">Guardar</v-btn>
            <v-btn color="secondary" @click="vehicleModal = false"
              >Cancelar</v-btn
            >
          </v-card-actions> -->
      </v-card>
    </v-dialog>
    <!-- Modal para buscar Vehículo -->
    <v-dialog v-model="searchVehicleDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline">Seleccionar Vehículo</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersVehicle"
            :items="vehicles"
            item-value="id"
            dense
            class="elevation-1"
            :search="searchVeh"
          >
            <template v-slot:top>
              <v-text-field
                v-model="searchVeh"
                label="Buscar"
                outlined
                dense
                class="mx-4 small-input"
              ></v-text-field>
            </template>
            <template v-slot:item="{ item }">
              <tr @click="selectVehicle(item)" class="clickable-row">
                <td>{{ item.plate }}</td>
                <td>{{ item.make }}</td>
                <td>{{ item.model }}</td>
                <td>{{ item.year }}</td>
                <td>{{ item.version }}</td>
                <td>{{ item.color }}</td>
                <td>{{ item.chassis_number }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="searchVehicleDialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="showErrorSnackbar"
      :timeout="snackbarTimeout"
      color="red darken-2"
      top
      right
      multi-line
    >
      <div v-for="(error, index) in errors" :key="index">
        {{ error }}
      </div>
    </v-snackbar>
  </v-card>
</template>
<script>
import axios from "@/plugins/axios.js";
import VehicleForm from "@/components/VehicleForm.vue";
import ClientDialog from "@/components/Client.vue";
export default {
  components: { VehicleForm, ClientDialog },
  data: () => ({
    vehicle: {
      id: null,
      make: "",
      model: "",
      year: "",
      version: "",
      plate: "",
      color: "",
      //price: 0,
      position: "",
      factory_id: "",
      vin: "",
      motor_number: "",
      chassis_make: "",
      motor_make: "",
      certificate_number: "",
      body_type: "",
    },
    visibleFields: [
      "make",
      "model",
      "year",
      "plate",
      "chassis_make",
      "chassis_number",
      "color",
      "motor_make",
      "motor_number",
      "certificate_number",
      "body_type",
      "status",
    ],
    rules: {
      required: (v) => !!v || "Este campo es obligatorio",
    },
    date: "",
    timeFrom: "",
    timeTo: "",
    kmIn: null,
    templates: [],
    template: {},
    client: {},
    plate: null,
    dni: null,
    clientModal: false,
    vehicleModal: false,
    newClient: { name: "" },
    newVehicle: { name: "" },
    vehicleSelected: {
      id: null,
      make: null,
      model: null,
    },
    clientSelected: {
      id: null,
      name: null,
      direction: null,
    },
    overlay: false,
    // buscar vehiculo
    searchVehicleDialog: false,
    headersVehicle: [
      { text: "Patente", value: "plate" },
      { text: "Marca", value: "make" },
      { text: "Modelo", value: "model" },
      { text: "Año", value: "year" },
      { text: "Serie", value: "version" },
      { text: "Color", value: "color" },
      { text: "Chasis", value: "chassis_number" },
      //{ text: "Precio", value: "price" },
    ],
    vehicles: [],
    searchVeh: "",
    vehicleSelected: {
      id: null,
      plate: null,
      model: null,
      model: null,
    },
    // fin
    // buscar cliente
    searchClientDialog: false,
    headersClient: [
      { text: "Dni", value: "dni" },
      { text: "Nombre", value: "first_name" },
      { text: "Apellido", value: "last_name" },
      { text: "Correo Electrónico", value: "email" },
      { text: "Teléfono", value: "phone" },
      { text: "Dirección", value: "address" },
    ],
    clientSelected: {
      id: null,
      make: null,
      model: null,
    },
    clients: [],
    searchCli: "",
    errors: [],
    showErrorSnackbar: false,
    snackbarTimeout: 6000, // tiempo visible en ms: [],
  }),
  computed: {
    completeName() {
      if (!this.clientSelected.first_name) return null;
      return `${this.clientSelected.first_name} ${this.clientSelected.last_name}`;
    },
  },
  mounted() {
    this.getTemplates();
  },
  methods: {
    getTemplates() {
      this.overlay = true;
      axios
        .get("/templates/getTemplates")
        .then((response) => {
          this.templates = response.data;
        })
        .catch((err) => {
          console.error("Error al obtener recursos:", err);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    // buscar vehiculo
    searchVehicleModal() {
      this.searchVehicleDialog = true;
      this.getVehicles();
    },
    getVehicles() {
      this.overlay = true;
      axios
        .get("/vehicles/getVehicles")
        .then((response) => {
          this.vehicles = [...response.data];
          this.overlay = false;
        })
        .catch((err) => {
          this.overlay = false;
        });
    },
    selectVehicle(vehicle) {
      this.vehicleSelected = vehicle;
      this.plate = vehicle.plate;
      this.searchVehicleDialog = false;
    },
    // fin
    // Buscar cliente
    searchClientModal() {
      this.searchClientDialog = true;
      this.getClients();
    },
    getClients() {
      this.overlay = true;
      axios
        .get("/clients/getClients")
        .then((response) => {
          this.clients = [...response.data];
          this.overlay = false;
        })
        .catch(() => {
          this.overlay = false;
        });
    },
    selectClient(client) {
      this.clientSelected = client;
      this.dni = client.dni;
      this.searchClientDialog = false;
    },
    onClientSaved(resp) {
      const client = resp.client;
      this.clientSelected = client;
      this.dni = this.clientSelected.dni;
      this.clientModal = false;
      this.overlay = false;
    },
    addVehicle(vehicle) {
      this.vehicle = vehicle;
      this.overlay = true;
      axios
        .post("vehicles/register", this.vehicle)
        .then((response) => {
          this.vehicleSelected = response.data.vehicle;
          this.plate = this.vehicleSelected.plate;
          this.vehicleModal = false;
          this.overlay = false;
          //this.clearForm();
        })
        .catch((err) => {
          this.overlay = false;
          this.errors = [];
          if (err.response && err.response.status === 422) {
            const serverErrors = err.response.data.errors;
            for (let field in serverErrors) {
              this.errors.push(...serverErrors[field]);
            }
          } else {
            this.errors.push(
              "Ocurrió un error inesperado al guardar el vehículo."
            );
            console.error(err);
          }
          this.showErrorSnackbar = true;
        });
    },
    openClientModal() {
      this.clientModal = true;
    },
    openVehicleModal() {
      this.$nextTick(() => {
        if (this.$refs.vehicleForm) {
          this.$refs.vehicleForm.clear();
        }
      });
      this.vehicleModal = true;
    },
    saveService() {
      this.overlay = true;
      axios
        .post("services/register", {
          templateId: this.template,
          vehicleId: this.vehicleSelected.id,
          clientId: this.clientSelected.id,
          date: this.date,
          timeFrom: this.timeFrom,
          timeTo: this.timeTo,
          kmIn: this.kmIn,
        })
        .then((response) => {
          this.overlay = false;
          this.$emit("changeView", "listado");
          //this.clearForm();
        })
        .catch((err) => {
          //console.log(err.response.data.error);
          this.overlay = false;
        });
    },
  },
};
</script>